export { default as RewardsCarousel } from './rewards-carousel';
